export interface IMondayElement {
  id: string;
  groupId: string | undefined;
  title: string;
  name: string; //alias for title
  url: string;
  parent_item: any;
  hasValues(): boolean;
  valueOfColumn(id: string): unknown;
  valuesOfColumnsByType(type: string): unknown[];
  updates: any;
  breadcrumbs(): null | string[];
}

export class MondayElement_integration implements IMondayElement {
  constructor(readonly element: any) {}

  get id(): string {
    return this.element.id;
  }

  get groupId(): string | undefined {
    return this.element.group?.id;
  }

  get title(): string {
    return this.element.name;
  }

  get name(): string {
    return this.element.name;
  }

  get url(): string {
    return this.element.url;
  }

  get parent_item(): any {
    return this.element.parent_item;
  }

  hasValues(): boolean {
    return this.element.columnValues && this.element.columnValues.length > 0;
  }

  valueOfColumn(id: string): unknown {
    if (!id) return undefined;
    return this.element.columnValues?.find((c: any) => c.id === id)?.value;
  }

  valuesOfColumnsByType(type: string): unknown[] {
    return this.element.columnValues?.filter((c: any) => c.type === type).map((c: any) => c.value);
  }

  get updates(): any {
    return this.element.updates;
  }

  breadcrumbs(): null | string[] {
    const { parent_item, board, group } = this.element;
    if (parent_item) {
      if (!parent_item.board?.name || !parent_item.name) {
        return null;
      }
      return [parent_item.board.name, parent_item.name, "Subitems"];
    } else {
      if (!board?.name || !group?.title) {
        return null;
      }
      return [board.name, group.title];
    }
  }
}
